import React, {
  Fragment, Component, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Popconfirm,
} from 'antd';
import {
  SettingOutlined, DeleteOutlined, LoadingOutlined, ReloadOutlined,
} from '@ant-design/icons';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import BusyIntegrationActions from '../../../../../actions/integrations/busyIntegrationAction';

const BusyIntegrationsLoading = (
  <div
    className="busy-list-wrapper"
  >
    <div
      className="loading-busy__card  "
    >
      <div className="busy-card-spacing">

        <div className="busy-card-header ">

          <div className="loadingBlock loading-busy-header__text" />
          <div className="loadingBlock loading-busy-header__image"> </div>
        </div>

        <div className="loadingBlock loading-busy-card__link"> </div>
        <div className="busy-card-footer">
          <div
            className="flex "
          >
            <p className="loadingBlock loading-busy-card__footer" />
          </div>
        </div>
      </div>
    </div>

  </div>
);

/**
 *
 */
const BusyConnectionList = ({
  user, getBusyConnectionsLoading, history, busyConnections,
  deleteBusyConnection, refreshBusyConnections, refreshBusyConnectionsLoading,
  deleteBusyConnectionLoading, getBusyConnections,
}) => {
  const [selectedRefreshItemId, setSelectedRefreshItemId] = useState(null);

  if (getBusyConnectionsLoading && !busyConnections) return <div className="busy-list-wrapper">{BusyIntegrationsLoading}</div>;
  const BusyConnectionCards = busyConnections?.filter((item) => item).map((item) => (
    <div key={item?.it_id} className={`busy-card ${(item?.status !== 'CONNECTED') ? 'busy-card-inactive' : ''}`}>
      <div className="busy-card-spacing">
        {item?.status === 'PENDING' ? (
          <div style={{ marginTop: '5%' }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              fontSize: '14px',
              justifyContent: 'center', // Centers children vertically in the container
              alignItems: 'center', // Centers children horizontally in the container
            }}
            >
              Establishing connection with your Busy account...
              <LoadingOutlined />
            </div>
          </div>
        ) : (
          <Fragment>
            <div className="busy-card-header">
              <p>
                {item?.company_name || '-'}
              </p>
              {item?.is_active && <img src={Success} alt="" className="busy-card-header__img" />}
            </div>
            <H3Text text={`${item?.available_locations?.length || 0} ${item?.available_locations?.length > 1 ? 'Branches' : 'Branch'}`} className="busy-card-link" />
          </Fragment>
        )}
        <div className="busy-card-footer">
          <div className="flex text-gray">
            <div style={{
              display: 'flex',
              'justify-content': 'space-between',
              width: '100%',
              'align-items': 'baseline',
            }}
            >
              {/* delete button */}
              <Popconfirm
                placement="topRight"
                // disabled
                title="Are you sure you want to delete this connection?"
                onConfirm={() => {
                  setSelectedRefreshItemId(item?.integration_busy_id);
                  const payload = {
                    integration_busy_id: item?.integration_busy_id,
                  };
                  deleteBusyConnection(payload, () => {
                    getBusyConnections();
                    setSelectedRefreshItemId(null);
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <div className={`delete-button ${deleteBusyConnectionLoading && selectedRefreshItemId === item?.integration_busy_id ? 'loading' : ''}`}>
                  {deleteBusyConnectionLoading && selectedRefreshItemId === item?.integration_busy_id ? (
                    <LoadingOutlined />
                  ) : (
                    <DeleteOutlined />
                  )}
                </div>
              </Popconfirm>
              {/* refresh button */}
              <div className="refresh-button">
                {!(refreshBusyConnectionsLoading && selectedRefreshItemId === item?.integration_busy_id) ? (
                  <ReloadOutlined
                    onClick={() => {
                      setSelectedRefreshItemId(item?.integration_busy_id);
                      const payload = {
                        integration_busy_id: item?.integration_busy_id,
                      };
                      refreshBusyConnections(payload, () => {
                        getBusyConnections();
                        setSelectedRefreshItemId(null);
                      });
                    }}
                  />
                ) : <LoadingOutlined />}
              </div>
              {/* edit button */}
              <div
                className="busy-card-footer__link"
                onClick={() => {
                  if (!getBusyConnectionsLoading) {
                    const id = item?.integration_busy_id;
                    history.push(`/admin/integration/busy/setup?integration_busy_id=${id}&step=${2}`);
                  }
                }}
              >
                {['READY', 'CONNECTED'].includes(item?.status) && (
                  <Fragment>
                    <SettingOutlined />
                    &nbsp;
                    Edit Configuration
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
  return (
    <div className="busy-list-wrapper">{BusyConnectionCards}</div>
  );
};

const mapStateToProps = ({ UserReducers, BusyIntegrationReducers }) => ({
  user: UserReducers.user,
  busyConnections: BusyIntegrationReducers.busyConnections,
  refreshBusyConnectionsLoading: BusyIntegrationReducers.refreshBusyConnectionsLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  deleteBusyConnectionLoading: BusyIntegrationReducers.deleteBusyConnectionLoading,
});

const mapDispatchToProps = (dispatch) => ({
  deleteBusyConnection: (payload, callback) => dispatch(BusyIntegrationActions.deleteBusyConnection(payload, callback)),
  refreshBusyConnections: (payload, callback) => dispatch(BusyIntegrationActions.refreshBusyConnections(payload, callback)),
  getBusyConnections: (payload, callback) => dispatch(BusyIntegrationActions.getBusyConnections(payload, callback)),
});
BusyConnectionList.propTypes = {
  user: PropTypes.any,
  getBusyConnections: PropTypes.any,
  busyConnections: PropTypes.any,
  getBusyConnectionsLoading: PropTypes.bool,
  history: PropTypes.any,
  deleteBusyConnection: PropTypes.any,
  refreshBusyConnections: PropTypes.any,
  refreshBusyConnectionsLoading: PropTypes.bool,
  deleteBusyConnectionLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyConnectionList));
